import React from 'react';

import { useSiteContext } from '@zooplus/commons-lang';

import { ENV } from '../../environment';

import styles from './TopBanner.module.scss';

const TopBanner = () => {
  const { site, language } = useSiteContext();

  let suffix;

  // if (site.country == 'CH') {
  //   suffix = 'CH';
  //   if (language == 'fr') {
  //     suffix = 'CHfr';
  //   }
  // } else if (site.country == 'IE') {
  //   suffix = 'GB';
  // } else if (site.country == 'GB') {
  //   suffix = 'UK';
  // } else {
  //   suffix = site.country;
  // }
  if (site.country == 'RU') {
    suffix = 'zoochic';
    language == 'ru';
  } else if (site.country == 'SI') {
    suffix = 'zoohit';
  } else if (site.country == 'SK') {
    suffix = 'zoohit';
  } else if (site.country == 'CZ') {
    suffix = 'zoohit';
  } else {
    suffix = 'zooplus';
  }

  return (
    <>
      <section>
        <div className={styles.TopBanner}>
          <picture>
            <source
              media="(max-width: 600px)"
              srcSet={`${ENV.IMAGE_CDN}/top-banner/xmas/2025_11_OwnBrands_Xmas_Umbrella_Header_500x320_${suffix}.jpg`}
            />
            <source
              media="(max-width: 1024px)"
              srcSet={`${ENV.IMAGE_CDN}/top-banner/xmas/2025_11_OwnBrands_Xmas_Umbrella_Header_2880x480_${suffix}.jpg`}
            />
            <img
              src={`${ENV.IMAGE_CDN}/top-banner/xmas/2025_11_OwnBrands_Xmas_Umbrella_Header_2880x480_${suffix}.jpg`}
              alt="Top banner"
              style={{ width: '100%', height: 'auto' }}
            />
            {/* <source
              media="(max-width: 600px)"
              srcSet={`${ENV.IMAGE_CDN}/top-banner/cyber/2025_11_Cyber_OwnBrands_General_${suffix}/2025_11_Cyber_OwnBrands_General_500x320_${suffix}.jpg`}
            />
            <source
              media="(max-width: 1024px)"
              srcSet={`${ENV.IMAGE_CDN}/top-banner/cyber/2025_11_Cyber_OwnBrands_General_${suffix}/2025_11_Cyber_OwnBrands_General_2880x480_${suffix}.jpg`}
            />
            <img
              src={`${ENV.IMAGE_CDN}/top-banner/cyber/2025_11_Cyber_OwnBrands_General_${suffix}/2025_11_Cyber_OwnBrands_General_2880x480_${suffix}.jpg`}
              alt="Top banner"
              style={{ width: '100%', height: 'auto' }}
            /> */}
            {/* <source
              media="(max-width: 600px)"
              srcSet={`${ENV.IMAGE_CDN}/top-banner/2025_07_OB_Price_Campaign_General_${suffix}/2025_07_OB_Price_Campaign_General_500x320_${suffix}.jpg`}
            />
            <source
              media="(max-width: 1024px)"
              srcSet={`${ENV.IMAGE_CDN}/top-banner/2025_07_OB_Price_Campaign_General_${suffix}/2025_07_OB_Price_Campaign_General_2880x480_${suffix}.jpg`}
            />
            <img
              src={`${ENV.IMAGE_CDN}/top-banner/2025_07_OB_Price_Campaign_General_${suffix}/2025_07_OB_Price_Campaign_General_2880x480_${suffix}.jpg`}
              alt="Top banner"
              style={{ width: '100%', height: 'auto' }}
            /> */}
          </picture>
        </div>
      </section>
    </>
  );
};

export default TopBanner;
